import { createContext, useContext, useState, useCallback } from "react";

const BriefContext = createContext(null);

export function BriefProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [offer, setOffer] = useState("general");

  const openBrief = useCallback((offerName = "general") => {
    setOffer(offerName);
    setOpen(true);
  }, []);

  const closeBrief = useCallback(() => setOpen(false), []);

  return (
    <BriefContext.Provider value={{ open, offer, openBrief, closeBrief, setOpen }}>
      {children}
    </BriefContext.Provider>
  );
}

export function useBrief() {
  const ctx = useContext(BriefContext);
  if (!ctx) throw new Error("useBrief must be used within BriefProvider");
  return ctx;
}
